'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _ContentTypes = require('../constants/ContentTypes');
var contentTypes = _interopRequireWildcard(_ContentTypes);
var _Row = require('./content_types/Row');
var _Row2 = _interopRequireDefault(_Row);
var _RowWithStripe = require('./content_types/RowWithStripe');
var _RowWithStripe2 = _interopRequireDefault(_RowWithStripe);
var _ExpandableRow = require('./content_types/ExpandableRow');
var _ExpandableRow2 = _interopRequireDefault(_ExpandableRow);
var _Column = require('./content_types/Column');
var _Column2 = _interopRequireDefault(_Column);
var _Button = require('./content_types/Button');
var _Button2 = _interopRequireDefault(_Button);
var _Countdown = require('./content_types/Countdown');
var _Countdown2 = _interopRequireDefault(_Countdown);
var _EventName = require('./content_types/EventName');
var _EventName2 = _interopRequireDefault(_EventName);
var _EventAddress = require('./content_types/EventAddress');
var _EventAddress2 = _interopRequireDefault(_EventAddress);
var _ExhibitorsGrid = require('./content_types/ExhibitorsGrid');
var _ExhibitorsGrid2 = _interopRequireDefault(_ExhibitorsGrid);
var _ExhibitorsLogos = require('./content_types/ExhibitorsLogos');
var _ExhibitorsLogos2 = _interopRequireDefault(_ExhibitorsLogos);
var _B2BMatchmaking = require('./content_types/B2BMatchmaking');
var _B2BMatchmaking2 = _interopRequireDefault(_B2BMatchmaking);
var _CookieConsent = require('./content_types/CookieConsent');
var _CookieConsent2 = _interopRequireDefault(_CookieConsent);
var _SponsorLogos = require('./content_types/SponsorLogos');
var _SponsorLogos2 = _interopRequireDefault(_SponsorLogos);
var _SponsorCards = require('./content_types/SponsorCards');
var _SponsorCards2 = _interopRequireDefault(_SponsorCards);
var _SpeakerList = require('./content_types/SpeakerList');
var _SpeakerList2 = _interopRequireDefault(_SpeakerList);
var _SpeakerTiles = require('./content_types/SpeakerTiles');
var _SpeakerTiles2 = _interopRequireDefault(_SpeakerTiles);
var _SpeakerSquareHover = require('./content_types/SpeakerSquareHover');
var _SpeakerSquareHover2 = _interopRequireDefault(_SpeakerSquareHover);
var _SpeakerCarousel = require('./content_types/SpeakerCarousel');
var _SpeakerCarousel2 = _interopRequireDefault(_SpeakerCarousel);
var _WorkshopList = require('./content_types/WorkshopList');
var _WorkshopList2 = _interopRequireDefault(_WorkshopList);
var _WorkshopZebra = require('./content_types/WorkshopZebra');
var _WorkshopZebra2 = _interopRequireDefault(_WorkshopZebra);
var _WorkshopRectangles = require('./content_types/WorkshopRectangles');
var _WorkshopRectangles2 = _interopRequireDefault(_WorkshopRectangles);
var _WorkshopDropdown = require('./content_types/WorkshopDropdown');
var _WorkshopDropdown2 = _interopRequireDefault(_WorkshopDropdown);
var _WorkshopNames = require('./content_types/WorkshopNames');
var _WorkshopNames2 = _interopRequireDefault(_WorkshopNames);
var _Iframe = require('./content_types/Iframe');
var _Iframe2 = _interopRequireDefault(_Iframe);
var _RegistrationIframe = require('./content_types/RegistrationIframe');
var _RegistrationIframe2 = _interopRequireDefault(_RegistrationIframe);
var _ResumeRegistration = require('./content_types/ResumeRegistration');
var _ResumeRegistration2 = _interopRequireDefault(_ResumeRegistration);
var _RegistrationTypeCards = require('./content_types/RegistrationTypeCards');
var _RegistrationTypeCards2 = _interopRequireDefault(_RegistrationTypeCards);
var _RegistrationTypeTable = require('./content_types/RegistrationTypeTable');
var _RegistrationTypeTable2 = _interopRequireDefault(_RegistrationTypeTable);
var _RegistrationTypeMulticolor = require('./content_types/RegistrationTypeMulticolor');
var _RegistrationTypeMulticolor2 = _interopRequireDefault(_RegistrationTypeMulticolor);
var _RegistrationTypeRows = require('./content_types/RegistrationTypeRows');
var _RegistrationTypeRows2 = _interopRequireDefault(_RegistrationTypeRows);
var _NetworkingLoginLink = require('./content_types/NetworkingLoginLink');
var _NetworkingLoginLink2 = _interopRequireDefault(_NetworkingLoginLink);
var _Text = require('./content_types/Text');
var _Text2 = _interopRequireDefault(_Text);
var _Link = require('./content_types/Link');
var _Link2 = _interopRequireDefault(_Link);
var _ImageWithLink = require('./content_types/ImageWithLink');
var _ImageWithLink2 = _interopRequireDefault(_ImageWithLink);
var _Navbar = require('./content_types/Navbar');
var _Navbar2 = _interopRequireDefault(_Navbar);
var _Footer = require('./content_types/Footer');
var _Footer2 = _interopRequireDefault(_Footer);
var _FooterInline = require('./content_types/FooterInline');
var _FooterInline2 = _interopRequireDefault(_FooterInline);
var _SimpleFooter = require('./content_types/SimpleFooter');
var _SimpleFooter2 = _interopRequireDefault(_SimpleFooter);
var _Image = require('./content_types/Image');
var _Image2 = _interopRequireDefault(_Image);
var _Map = require('./content_types/Map');
var _Map2 = _interopRequireDefault(_Map);
var _Html = require('./content_types/Html');
var _Html2 = _interopRequireDefault(_Html);
var _Carousel = require('./content_types/Carousel');
var _Carousel2 = _interopRequireDefault(_Carousel);
var _VideoPlayer = require('./content_types/VideoPlayer');
var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
var _ContactForm = require('./content_types/ContactForm');
var _ContactForm2 = _interopRequireDefault(_ContactForm);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var StaticContent = function StaticContent(props) {
  switch (props.type) {
    case contentTypes.ROW:
      return _react2.default.createElement(_Row2.default, props);
    case contentTypes.ROW_WITH_STRIPE:
      return _react2.default.createElement(_RowWithStripe2.default, props);
    case contentTypes.EXPANDABLE_ROW:
      return _react2.default.createElement(_ExpandableRow2.default, props);
    case contentTypes.TEXT:
      return _react2.default.createElement(_Text2.default, props);
    case contentTypes.LINK:
      return _react2.default.createElement(_Link2.default, props);
    case contentTypes.IMAGE_WITH_LINK:
      return _react2.default.createElement(_ImageWithLink2.default, props);
    case contentTypes.COLUMN:
      return _react2.default.createElement(_Column2.default, props);
    case contentTypes.BUTTON:
      return _react2.default.createElement(_Button2.default, props);
    case contentTypes.COUNTDOWN:
      return _react2.default.createElement(_Countdown2.default, props);
    case contentTypes.EVENT_NAME:
      return _react2.default.createElement(_EventName2.default, props);
    case contentTypes.EVENT_ADDRESS:
      return _react2.default.createElement(_EventAddress2.default, props);
    case contentTypes.SPONSOR_LOGOS:
      return _react2.default.createElement(_SponsorLogos2.default, props);
    case contentTypes.SPONSOR_CARDS:
      return _react2.default.createElement(_SponsorCards2.default, props);
    case contentTypes.SPEAKER_LIST:
      return _react2.default.createElement(_SpeakerList2.default, props);
    case contentTypes.SPEAKER_TILES:
      return _react2.default.createElement(_SpeakerTiles2.default, props);
    case contentTypes.SPEAKER_SQUARE_HOVER:
      return _react2.default.createElement(_SpeakerSquareHover2.default, props);
    case contentTypes.SPEAKER_CAROUSEL:
      return _react2.default.createElement(_SpeakerCarousel2.default, props);
    case contentTypes.WORKSHOP_LIST:
      return _react2.default.createElement(_WorkshopList2.default, props);
    case contentTypes.WORKSHOP_ZEBRA:
      return _react2.default.createElement(_WorkshopZebra2.default, props);
    case contentTypes.WORKSHOP_RECTANGLES:
      return _react2.default.createElement(_WorkshopRectangles2.default, props);
    case contentTypes.WORKSHOP_DROPDOWN:
      return _react2.default.createElement(_WorkshopDropdown2.default, props);
    case contentTypes.WORKSHOPS_BY_NAME:
      return _react2.default.createElement(_WorkshopNames2.default, props);
    case contentTypes.REGISTRATION_IFRAME:
      return _react2.default.createElement(_RegistrationIframe2.default, props);
    case contentTypes.RESUME_REGISTRATION:
      return _react2.default.createElement(_ResumeRegistration2.default, props);
    case contentTypes.REGISTRATION_TYPE_CARDS:
      return _react2.default.createElement(_RegistrationTypeCards2.default, props);
    case contentTypes.REGISTRATION_TYPE_TABLE:
      return _react2.default.createElement(_RegistrationTypeTable2.default, props);
    case contentTypes.REGISTRATION_TYPE_MULTICOLOR:
      return _react2.default.createElement(_RegistrationTypeMulticolor2.default, props);
    case contentTypes.REGISTRATION_TYPE_ROWS:
      return _react2.default.createElement(_RegistrationTypeRows2.default, props);
    case contentTypes.NETWORKING_LOGIN_LINK:
      return _react2.default.createElement(_NetworkingLoginLink2.default, props);
    case contentTypes.NAVBAR:
      return _react2.default.createElement(_Navbar2.default, props);
    case contentTypes.FOOTER:
      return _react2.default.createElement(_Footer2.default, props);
    case contentTypes.FOOTER_INLINE:
      return _react2.default.createElement(_FooterInline2.default, props);
    case contentTypes.SIMPLE_FOOTER:
      return _react2.default.createElement(_SimpleFooter2.default, props);
    case contentTypes.IMAGE:
      return _react2.default.createElement(_Image2.default, props);
    case contentTypes.MAP:
      return _react2.default.createElement(_Map2.default, props);
    case contentTypes.B2B_MATCHMAKING_GRID:
      return _react2.default.createElement(_B2BMatchmaking2.default, props);
    case contentTypes.COOKIE_CONSENT_SMALL:
      return _react2.default.createElement(_CookieConsent2.default, props);
    case contentTypes.EXHIBITORS_GRID:
      return _react2.default.createElement(_ExhibitorsGrid2.default, props);
    case contentTypes.EXHIBITORS_LOGOS:
      return _react2.default.createElement(_ExhibitorsLogos2.default, props);
    case contentTypes.HTML:
      return _react2.default.createElement(_Html2.default, props);
    case contentTypes.IFRAME:
      return _react2.default.createElement(_Iframe2.default, props);
    case contentTypes.CAROUSEL:
      return _react2.default.createElement(_Carousel2.default, props);
    case contentTypes.VIDEO_PLAYER:
      return _react2.default.createElement(_VideoPlayer2.default, props);
    case contentTypes.CONTACT_FORM:
      return _react2.default.createElement(_ContactForm2.default, props);
    default:
      console.error('Unknown content type:', props.type);
      // throw 'Unknown content type'
      return null;
  }
};
StaticContent.propTypes = {
  type: _propTypes2.default.string.isRequired
};
exports.default = StaticContent;